import { LayoutPage } from "pages/_Layout/Layout.page"
import { BlankComponent } from "sections/Blank/Blank.component"
import { FooterComponent } from "sections/Footer/Footer.component"
import { FunctionsComponent } from "sections/Functions/Functions.component"
import { NavbarComponent } from "sections/Navbar/Navbar.component"
import { OtherProductComponent } from "sections/Product/OtherProduct.component"

export const OtherProductPage = ({
    categoryId
  } : {
    categoryId: string
  }
) => {
  return (
    <LayoutPage>
      <>
        <NavbarComponent />

        <OtherProductComponent categoryId={categoryId} />

        <BlankComponent size="1/3" />

        <FunctionsComponent />

        <BlankComponent size="1/3" />

        <FooterComponent />
      </>
    </LayoutPage>
  )
}
